/**
 * Front-end behavior for Icon Grid (scoped to block instances).
 */
export class IconGridFront {
	/**
	 * @param {ParentNode} root
	 */
	constructor( root = document ) {
		this.root = root;
	}

	init() {
		this.root.querySelectorAll( '[data-block="icon-grid"]' ).forEach( ( el ) => {
			el.classList.add( 'icon-grid-enhanced' );
		} );
	}
}
